import Button from "../Button/Button"
import EmailTableList from "./EmailsTable"
import React, { useState } from "react"
import Email from "./Email"
import { LuSend, LuInbox, LuPlus } from "react-icons/lu"

const AllEmails = ({ setTab, userData, userId }) => {
  const [activeTab, setActiveTab] = useState('sent')
  const [openEmail, setOpenEmail] = useState('')
  const [countMailsTab, setCountMailsTab] = useState({
    sentLettersCount: 0,
    inboxLettersCount: 0
  })

  const handleTabChange = (tab) => {
    setActiveTab(tab)
  }

  return (
    <div className="flex w-full rounded-2xl mb-6 shadow-lg border border-divider min-h-[400px]">
      <div className="max-w-[280px] min-w-[200px] w-full border-r border-divider">
        <div className="px-5 py-[22px] border-b border-divider">
          <Button width="w-full" onClick={() => setTab("compose")}>
            <div className={"flex justify-center items-start gap-2"}>
              {
                <LuPlus size={18} />
              }Compose
            </div>
          </Button>
        </div>
        <div className="w-full">
          <div onClick={() => handleTabChange("sent")}
            className={`${activeTab === "sent" ? 'bg-surface' : ''} cursor-pointer gap-4 flex h-[48px] px-5 py-3 items-center w-full`}>
            <LuSend size={18} className={activeTab === "sent" ? 'text-text-primary' : 'text-text-secondary'} />
            <div className="flex justify-between w-full">
              <div>Sent</div>
              <div>{countMailsTab?.sentLettersCount}</div>
            </div>
          </div>
        </div>
        <div className="w-full">
          <div onClick={() => handleTabChange("inbox")}
            className={`${activeTab === "inbox" ? 'bg-surface' : ''} cursor-pointer gap-4 flex h-[48px] px-5 py-3 items-center w-full`}>
            <LuInbox size={18} className={activeTab === "inbox" ? 'text-text-primary' : 'text-text-secondary'} />
            <div className="flex justify-between w-full">
              <div>Inbox</div>
              <div>{countMailsTab?.inboxLettersCount}</div>
            </div>
          </div>
        </div>
      </div>
      <div className="w-full">
        {openEmail?.length === 0 ?
          <EmailTableList userId={userId} countMailsTab={countMailsTab} setCountMailsTab={setCountMailsTab}
            setOpenEmail={setOpenEmail} activeTab={activeTab} /> :
          <Email userData={userData} openEmail={openEmail} setOpenEmail={setOpenEmail} />}
      </div>
    </div>
  )
}
export default AllEmails